// extracted by mini-css-extract-plugin
export default {"picture":"BannerImage_picture__YOnGN","link":"BannerImage_link__qGIXC"};